import mqtt from "mqtt";
import { getMqttURL, } from "./helpers";

export declare type MQTTConnectProps = {
	timeout?: number;
}

export const getConnection = async ({
	timeout = 30000,
}: MQTTConnectProps = {}): Promise<mqtt.MqttClient> => {

	return new Promise((resolve, reject) => {

		const timer = setTimeout(() => {
			clearTimeout(timer);
			reject(new Error(`RMQ connection timed out after ${(timeout / 1000).toString()} seconds.`));
		}, timeout);

		const client = mqtt.connect(getMqttURL());
		client.on("connect", () => {
			clearTimeout(timer);
			resolve(client)
		});

		client.on("error", err => {
			clearTimeout(timeout);
			if(document.location.hostname === "localhost") {
				console.error("MQTT has errored", err);
			}
			reject(new Error(`@bracket/rabbit failed to gain a connection - ${err.message}`))
		});

	})

}
